import React from 'react';
import IconGlyph from './IconGlyph';
import { getRateSeparatorBarColors } from '../utils/rateSeparatorUtil';
import '../css/RateSeparatorBar.css';

/**
 * Rate separator Design 2: a full-width tinted bar — icon, rate name and
 * hours on the left, the price in a badge on the right — e.g.
 * "🔥 PEAK RATE · 12:00 PM – 5:00 PM          ₱650/hr".
 *
 * Tinted from the band's own colour when set; without one it uses the club's
 * accent (Config -> Theme). The bar is always a pale tint, so the name reads
 * in the configured text colour whatever colour the admin picks.
 *
 * @param {object} props
 * @param {string} [props.name] - the band's name, shown in capitals
 * @param {string} [props.icon] - emoji or Iconify id
 * @param {string} [props.color] - the band's colour, hex
 * @param {string} [props.price] - formatted price, e.g. "₱650/hr"
 * @param {string} [props.hours] - formatted hours, e.g. "12:00 PM – 5:00 PM"
 * @returns {JSX.Element}
 */
function RateSeparatorBar({ name, icon, color, price, hours }) {
  const colors = getRateSeparatorBarColors(color);
  const barStyle = colors ? { background: colors.background } : undefined;
  const accentStyle = colors ? { color: colors.accent } : undefined;
  const badgeStyle = colors ? { background: colors.badgeBackground, color: colors.accent } : undefined;

  return (
    <span className="rsb-bar" style={barStyle}>
      <span className="rsb-main">
        {icon && <span className="rsb-icon" style={accentStyle}><IconGlyph icon={icon} /></span>}
        {name && <span className="rsb-name">{name}</span>}
        {name && hours && <span className="rsb-dot" aria-hidden="true">·</span>}
        {hours && <span className="rsb-hours">{hours}</span>}
      </span>
      {price && <span className="rsb-price" style={badgeStyle}>{price}</span>}
    </span>
  );
}

export default RateSeparatorBar;
